<div [hidden]="!loadingprogress" class="w3-modal">
    <div class="w3-modal-content">
        <img style="width: 100%; height: 100%;" src="../../../assets/images/giphy2.gif">
    </div>
</div>
